import React, { Component } from 'react';
import Layout from "../../shared/components/layouts/MainLayout";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import circleCheck from "../../../assets/images/circle-check.svg";

class FCPaymentCompleted extends Component {

  goBackToSupplierPayments = () => {
    const { leadId } = this.props;
    const url = `${process.env.REACT_APP_FC_CONNECT_BASE_URL}/leads/${leadId}/home`
    window.location = url
  }

  render() {
    return (
      <Layout gridClassName="--narrow">
        <div className="ds-card _textAlign_center _padding--xlarge">
          <section className="cardSection">
          <img className="_marginBottom--normal" src={circleCheck} alt='circle-check' />
            <h2 className="headline -primary _fontSize--xlarge _marginBottom--small">Supplier payment request sent.</h2>
            <p className="_marginBottom--small byline">Your request is now being verified.</p>
            <p className="_marginBottom--medium byline">
              Once approved, we will send the<br/>
              payment disbursement details to<br />
              <span className="_marginBottom--small -primary">
                <b>{` ${this.props.user_email}`}</b>
              </span>
            </p>

            <button
              className="ds-btn --block -primary"
              onClick={this.goBackToSupplierPayments}
            >
              Go back to Supplier Payments
            </button>
          </section>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user_email: state.user.email,
    leadId: (state.user.active_business_trustpass || {}).lead_id,
  };
};

const mapDispatchToProps = (dispatch, _props) => {
  return {
    push: (url) => dispatch(push(url)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FCPaymentCompleted);



// WEBPACK FOOTER //
// ./src/features/loans/containers/FCPaymentCompleted.js